<template>
  <div class="animated fadeIn shift">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 v-if="mData.viewMode == 'create'">Thêm mới ca</h4>
            <h4 v-if="mData.viewMode == 'detail'">Chi tiết ca</h4>
            <h4 v-if="mData.viewMode == 'update'">Cập nhật ca</h4>
          </div>
          <div class="text-right">
            <el-button
              v-if="mData.viewMode == 'update' && validShift === true"
              class="mb-2 btn-radius-10 btn-default"
              @click="showHideDialogHint"
              round
              >Gợi ý phân ca</el-button
            >
            <el-button
              class="mb-2 btn-default"
              v-if="mData.viewMode == 'create'"
              @click="submitForm('create')"
              round
              :disabled="!checkValidate"
              >Thêm mới</el-button
            >
            <el-button
              class="mb-2 btn-default"
              v-if="mData.viewMode == 'update'"
              @click="submitForm('update')"
              :disabled="!checkValidate"
              round
              >Lưu</el-button
            >
            <el-button
              class="mb-2 btn-back"
              @click="fn_go"
              round
              >Quay lại</el-button
            >
          </div>
        </div>
        <div class="main-body scroll-css">
          <el-form
            class="shift-form"
            :model="mData.dataForm"
            :rules="mData.validForm"
            ref="myForm"
            label-position="left"
            @submit.native.prevent
            label-width="170px"
          >
            <b-row>
              <b-col md="6">
                <el-form-item label="Mã ca" prop="code">
                  <el-input
                    @input="forceUpdateUI()"
                    :disabled="mData.viewMode == 'detail'"
                    v-model.trim="mData.dataForm.code"
                    @change="() => {this.mData.dataForm.code = this.mData.dataForm.code.toUpperCase()}"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Tên ca" prop="name">
                  <el-input
                    @input="forceUpdateUI()"
                    :disabled="mData.viewMode == 'detail'"
                    v-model="mData.dataForm.name"
                    @change="() => {this.mData.dataForm.name = this.mData.dataForm.name.trim()}"
                    clearable
                  >
                  </el-input>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item
                  label="Ngày hiệu lực từ"
                  prop="applied_start_time"
                >
                  <el-date-picker
                    @input="forceUpdateUI()"
                    :disabled="mData.viewMode == 'detail'"
                    v-model="mData.dataForm.applied_start_time"
                    type="date"
                    placeholder=""
                    :picker-options="pickerOptionsFrom"
                    format="dd/MM/yyyy"
                    ref="start_time"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Ngày hiệu lực tới" prop="applied_end_time">
                  <el-date-picker
                    @input="forceUpdateUI()"
                    :disabled="mData.viewMode == 'detail'"
                    v-model="mData.dataForm.applied_end_time"
                    type="date"
                    :picker-options="pickerOptionsTo"
                    placeholder=""
                    format="dd/MM/yyyy"
                    ref="end_time"
                  >
                  </el-date-picker>
                </el-form-item>
              </b-col>
              <b-col md="6">
                <el-form-item label="Tính công" prop="work_number_payment">
                  <el-select
                    @input="forceUpdateUI()"
                    :disabled="mData.viewMode == 'detail'"
                    v-model="mData.dataForm.work_number_payment"
                    placeholder=""
                  >
                    <el-option
                      v-for="item in mData.dataDefault.listTinhCong"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </b-col>
              <b-col sm="6">
                <el-checkbox
                  class="mt-2"
                  :disabled="mData.viewMode == 'detail'"
                  @change="changeStatusOddShift(), forceUpdateUI()"
                  v-model="mData.dataForm.is_odd_shift"
                >
                  Có nghỉ giữa ca
                </el-checkbox>
              </b-col>
            </b-row>

            <b-row class="">
              <b-col md="12" class="mb-2">
                <div class="title-work-day">
                  <p class="bold title">Ngày làm việc</p>
                  <el-popover placement="bottom-start" trigger="hover">
                    <div>
                      <b-row class="popper-popup">
                        <b-col md="12" class="popper-popup_box">
                          <p class="bold" style="font-size: 16px">Lưu ý</p>
                          <ul style="padding-inline-start: 33px">
                            <li>
                              Cần phải nhập: Thời gian, chu kỳ lặp, ngày công
                            </li>
                            <li>
                              Nếu chọn có nghỉ giữa ca thì phải nhập tên từng ca
                              lẻ
                            </li>
                          </ul>
                        </b-col>
                      </b-row>
                    </div>
                    <i slot="reference" class="fas fa-info-circle fa-lg"></i>
                  </el-popover>
                </div>
              </b-col>
              <b-col md="12">
                <el-table
                  :data="myData"
                  stripe="stripe"
                  show-summary
                  max-height="570"
                >
                  <el-table-column
                    prop="name"
                    label="Thứ"
                    width="80"
                    align="center"
                  >
                    <template slot-scope="scope">
                      {{scope.row.name && scope.row.name == "8" ? "CN" : scope.row.name}}
                    </template>
                  </el-table-column>
                  <el-table-column label="Thời gian" min-width="300px">
                    <el-table-column prop="state" min-width="220">
                      <template slot="header">
                        <input
                          :class="
                            mData.dataForm.is_odd_shift !== true ||
                            mData.viewMode == 'detail' ?
                            'fake-input_elementUi disabled' :
                            'fake-input_elementUi'
                          "
                          v-model="mData.odd_names_first"
                          ref="odd_names_first"
                          size="mini"
                          placeholder=""
                          clearable
                          :disabled="
                            mData.dataForm.is_odd_shift !== true ||
                              mData.viewMode == 'detail'
                          "
                          @input="forceUpdateUI()"
                          @change="() => {this.mData.odd_names_first = this.mData.odd_names_first.trim()}"
                          @blur="
                            changeOddName(
                              mData.odd_names_first,
                              'odd_names_first'
                            )
                          "
                        />
                      </template>
                      <template slot-scope="scope">
                        <input
                          :class="mData.viewMode == 'detail' ?
                            'fake-input_elementUi disabled' :
                            'fake-input_elementUi'
                          "
                          v-model="myData[scope.$index].first_time"
                          :ref="`firstTime_${scope.$index}`"
                          size="mini"
                          placeholder="hh:mm - hh:mm"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI()"
                          @blur="changeTimeLog(scope.$index,'firstTime_')"
                          @change="() => {myData[scope.$index].first_time = myData[scope.$index].first_time.trim()}"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="state"
                      min-width="220"
                      v-if="mData.dataForm.is_odd_shift === true"
                    >
                      <template slot="header">
                        <input
                          class="fake-input_elementUi"
                          clearable
                          :disabled="mData.viewMode == 'detail'"
                          v-model="mData.odd_names_second"
                          size="mini"
                          placeholder=""
                          ref="odd_names_second"
                          @input="forceUpdateUI()"
                          @change="() => {this.mData.odd_names_second = this.mData.odd_names_second.trim()}"
                          @blur="
                            changeOddName(
                              mData.odd_names_second,
                              'odd_names_second'
                            )
                          "
                        />
                      </template>
                      <template slot-scope="scope">
                        <input
                          :class="
                            mData.dataForm.is_odd_shift !== true ||
                            mData.viewMode == 'detail' ?
                            'fake-input_elementUi disabled' :
                            'fake-input_elementUi'
                          "
                          v-model="myData[scope.$index].seconde_time"
                          :ref="`secondTime_${scope.$index}`"
                          size="mini"
                          placeholder="hh:mm - hh:mm"
                          :disabled="mData.viewMode == 'detail'"
                          @input="forceUpdateUI()"
                          @blur="changeTimeLog(scope.$index,'secondTime_')"
                          @change="() => {myData[scope.$index].seconde_time = myData[scope.$index].seconde_time.trim()}"
                        />
                      </template>
                    </el-table-column>
                  </el-table-column>
                  <el-table-column
                    prop="col2"
                    label="Chu kỳ lặp"
                    min-width="130"
                  >
                    <template slot-scope="scope">
                      <el-select
                        :disabled="mData.viewMode == 'detail'"
                        v-model="myData[scope.$index].iteration_cycle"
                        placeholder=""
                        clearable
                        :key="componentKey"
                        @change="forceRerender"
                      >
                        <el-option
                          v-for="item in mData.dataDefault.listChuKyLap"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="hour_work"
                    label="Giờ công"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>
                        {{
                          myData[scope.$index].hour_work === 0
                            ? ""
                            : myData[scope.$index].hour_work
                        }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="number_word_day"
                    label="Ngày công"
                    width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        :controls="false"
                        :max="1"
                        :min="0"
                        @input="forceUpdateUI()"
                        :disabled="mData.viewMode == 'detail'"
                        v-model="myData[scope.$index].number_word_day"
                        @change="() => {
                            myData[scope.$index].number_word_day = Math.round((myData[scope.$index].number_word_day) * 100) / 100
                        }"
                        size="mini"
                        placeholder=""
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="day_off_number"
                    label="Số ngày nghỉ quy đổi"
                    width="200"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        :controls="false"
                        :min="0"
                        @input="forceUpdateUI()"
                        :disabled="mData.viewMode == 'detail'"
                        v-model="myData[scope.$index].day_off_number"
                        @change="() => {
                            myData[scope.$index].day_off_number = Math.round((myData[scope.$index].day_off_number) * 100) / 100
                        }"
                        size="mini"
                        placeholder=""
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </b-col>
            </b-row>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      title="Gợi ý phân ca"
      :visible.sync="mData.dialogHint"
      width="500px"
      :before-close="fn_resetFormDivision"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <p class="titel_phan_ca">
        Phân công cho những nhân viên có ca làm việc cũ sang ca làm việc
        {{ mData.dataForm.code }}.
      </p>
      <p class="work-brake mb-3">Chọn ca làm việc cũ:</p>
      <el-form
        ref="myListForm"
        label-position="left"
        @submit.native.prevent
        label-width="150px"
      >
        <b-row>
          <b-col md="12">
            <el-form-item label="Ca làm việc" prop="list_shift">
              <el-select
                filterable
                clearable
                v-model="mData.division_id"
                placeholder="Chọn ca làm việc"
                @change="changeShift()"
              >
                <el-option
                  v-for="item in mData.dataDefault.listValidShift"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="Thời gian bắt đầu" prop="timeStart">
              <el-date-picker
                v-model="mData.timeStart"
                type="date"
                :editable="false"
                format="dd/MM/yyyy"
                :picker-options="pickerOptions"
                placeholder=""
              >
              </el-date-picker>
            </el-form-item>
          </b-col>
        </b-row>
        <div class="text-center">
          <el-button @click="division" type="primary" round class="btn-default"
            >Phân ca</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import DataService from '../../../../../service/DataService'
import MethodService from '../../../../../service/MethodService'
import ShiftModel from './ShiftModel'
import ShiftApi from '../../../../../moduleApi/ShiftApi'
import TimeBar from '../../../../../component/Timekeeping/TimeBar'
import ValidService from '../../../../../service/ValidService'
import ElementUiMoney from '../../../../../component/InputComponent/ElementUiMoney'

export default {
  components: {
    TimeBar,
    ElementUiMoney,
  },
  data() {
    return {
      checkValidate: true,
      validShift: true,
      load: false,
      componentKey: 0,
      pickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() <
            new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          )
        }
      },
      pickerOptionsFrom: {
        disabledDate(time) {
          return (
            time.getTime() <
            new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          )
        }
      },
      pickerOptionsTo: {
        disabledDate(time) {
          return (
            time.getTime() <
            new Date(new Date().valueOf() - 1000 * 60 * 60 * 24).getTime()
          )
        }
      },
      validservice: ValidService,
      value1: null,
      myData: [],
      dialogSuggestionsDivision: false,
      mData: {
        odd_names_first: undefined,
        odd_names_second: undefined,
        calculate_overtime: undefined,
        acceptance_time_keeping: undefined,
        division_id: undefined,
        timeStart: undefined,
        appliedEndTime: undefined,
        appliedStartTime: undefined,
        moduleName: "Shift", //requied
        viewMode: "create",
        dialogHint: false,
        tableRules: MethodService.copyObject(ShiftModel.tableRules),
        dataForm: MethodService.copyObject(ShiftModel.dataForm),
        validForm: ShiftModel.validForm,
        dataDefault: {
          listQuyDoiCong: DataService.listQuyDoiCong,
          listTinhCong: DataService.listTinhCong,
          listChuKyLap: DataService.listChuKyLap,
          listValidShift: []
        }
      },
    }
  },
  methods: {
    forceRerender() {
      this.componentKey += 1
      if (this.componentKey >= 10) {
        this.componentKey = 0
      }
    },
    changeStatusOddShift() {
      if (this.mData.dataForm.is_odd_shift === false) {
        this.myData.forEach((e,i) => {
          if (e.seconde_time) {
            delete this.myData[i].seconde_time
          }
          if (e.first_time) {
            let arrFirstTime = this.splitTime(this.splitTimeInput(e.first_time)[0]);
            let arrSecondTime = this.splitTime(this.splitTimeInput(e.first_time)[1]);
            let firstStartTimeTotal = parseInt(arrFirstTime[0]) + Math.round((parseInt(arrFirstTime[1]) / 60) * 100) / 100;
            let firstEndTimeTotal = parseInt(arrSecondTime[0]) + Math.round((parseInt(arrSecondTime[1]) / 60) * 100) / 100;
            this.myData[i].hour_work = Math.round((firstEndTimeTotal - firstStartTimeTotal) * 100) / 100;
            this.forceUpdateUI();
            this.renderDataTable();
          }
        })
      }
      this.mData.odd_names_first = undefined;
      this.renderDataTable();
    },
    splitTimeInput(time){
      let timearray = time.split("-");
      return timearray;
    },
    checkValidTime(value){
      if (
        (parseInt(value[0]) < 0 || parseInt(value[0]) > 23) ||
        (parseInt(value[1]) < 0 || parseInt(value[1]) > 59)
      ) {
        window.toastr.warning("Thời gian không hợp lệ");
        return false;
      } else {
        return true;
      }
    },
    checkValidTimeBeforeAfter(value){
      let now = new Date();
      if (
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(value[0][[0]]),parseInt(value[0][1]),0).getTime() >=
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(value[1][[0]]),parseInt(value[1][1]),0).getTime()
      ) {
        window.toastr.warning("Thời gian trước phải bé hơn thời gian sau!");
        return false
      } else {
        return true
      }
    },
    checkValidTimeBeforeAfterHaveOddShift(value1,value2){
      let now = new Date();
      let arrFirstTime =  this.splitTime(this.splitTimeInput(value1)[1]);
      let arrSecondTime =  this.splitTime(this.splitTimeInput(value2)[0]);
      if (
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(arrFirstTime[0]),parseInt(arrFirstTime[1]),0).getTime() >=
        new Date(now.getFullYear(), now.getMonth(), now.getDate(), parseInt(arrSecondTime[0]),parseInt(arrSecondTime[1]),0).getTime()
      ) {
        window.toastr.warning("Thời gian bắt đầu của ca lẻ sau phải lớn hơn thời gian kết thúc của ca lẻ  trước!");
        return false
      } else {
        return true
      }
    },
    changeTimeLog(index,type) {
      if (this.$router.currentRoute.name != "Admin-Timekeeping-TimekeepingConfig-Shift-create" && this.$router.currentRoute.name != "Admin-Timekeeping-TimekeepingConfig-Shift-update") {
        return
      }
      let regex = /^\d{1,2}:\d{2}\s?-\s?\d{1,2}:\d{2}$/;
      let html = "<p style='color: #fff;font-size:16px;'>Sai định dạng giờ</p> <p style='color: #fff;font-size:16px;'>VD: hh:mm - hh:mm</p>";
      let firstTimeWorkSign = 0;
      let secondTimeWorkSign = 0;
      //Có nghỉ giữa giờ
      if (this.mData.dataForm.is_odd_shift === true) {
        if (this.myData[index].first_time && this.myData[index].seconde_time) {
          if (!this.checkValidTimeBeforeAfterHaveOddShift(this.myData[index].first_time,this.myData[index].seconde_time)) {
            if (this.$refs[type+index])
              this.$refs[type+index].focus();
            return
          }
        }
      }
      //First time
      if (this.myData[index].first_time) {
        let checkRegex = regex.test(this.myData[index].first_time);
        if (!checkRegex) {
          window.toastr.warning(html,"");
          this.checkValidate = false;
          this.$refs[type+index].focus();
          return
        } else {
          let arrFirstTime =  this.splitTimeInput(this.myData[index].first_time);
          if (arrFirstTime.length == 2) {
            let timeStartArrFirst = this.splitTime(arrFirstTime[0]);
            let timeEndArrFirst = this.splitTime(arrFirstTime[1]);
            if (this.mData.dataForm.is_pass_day === false) {
              if (!this.checkValidTimeBeforeAfter([timeStartArrFirst,timeEndArrFirst])) {
                this.$refs[type+index].focus();
                return
              }
            }
            if (!this.checkValidTime(timeStartArrFirst) || !this.checkValidTime(timeEndArrFirst)) {
              this.$refs[type+index].focus();
              return
            }
            this.myData[index].period_time[0].start_time = {
              hour: Number(timeStartArrFirst[0].trim()),
              minute: Number(timeStartArrFirst[1].trim())
            };
            this.myData[index].period_time[0].end_time = {
              hour: Number(timeEndArrFirst[0].trim()),
              minute: Number(timeEndArrFirst[1].trim())
            };
            this.checkValidate = true;
          }
        }
      } else {
        this.myData[index].period_time[0].start_time = {};
        this.myData[index].period_time[0].end_time = {};
      }

      //Second time
      if (this.myData[index].seconde_time) {
        let checkRegex = regex.test(this.myData[index].seconde_time);
        if (!checkRegex) {
          window.toastr.warning(html,"");
          this.checkValidate = false;
          this.$refs[type+index].focus();
          return
        } else {
          let arrSecondTime =  this.splitTimeInput(this.myData[index].seconde_time);
          if (arrSecondTime.length == 2) {
            let timeStartArrSecond = this.splitTime(arrSecondTime[0]);
            let timeEndArrSecond = this.splitTime(arrSecondTime[1]);
            if (!this.checkValidTimeBeforeAfter([timeStartArrSecond,timeEndArrSecond])) {
              this.$refs[type+index].focus();
              return
            }
            if (!this.checkValidTime(timeStartArrSecond) || !this.checkValidTime(timeEndArrSecond)) {
              this.$refs[type+index].focus();
              return
            }
            this.myData[index].period_time[1].start_time = {
              hour: Number(timeStartArrSecond[0].trim()),
              minute: Number(timeStartArrSecond[1].trim())
            };
            this.myData[index].period_time[1].end_time = {
              hour: Number(timeEndArrSecond[0].trim()),
              minute: Number(timeEndArrSecond[1].trim())
            };
          }
          this.checkValidate = true;
        }
      } else {
        this.myData[index].period_time[1].start_time = {};
        this.myData[index].period_time[1].end_time = {};
      }

      let firstStartTimeTotal = this.myData[index].period_time[0].start_time.hour + Math.round((this.myData[index].period_time[0].start_time.minute / 60) * 100) / 100;

      let firstEndTimeTotal = this.myData[index].period_time[0].end_time.hour + Math.round((this.myData[index].period_time[0].end_time.minute / 60) * 100) / 100;
      if (this.myData[index].period_time[0].start_time.hour > this.myData[index].period_time[0].end_time.hour) {
        firstTimeWorkSign = Math.round(((24 - firstStartTimeTotal) + firstEndTimeTotal) * 100) / 100;
      } else {
        firstTimeWorkSign = Math.round((firstEndTimeTotal - firstStartTimeTotal) * 100) / 100;
      }


      if (this.myData[index].period_time[1].end_time.hour) {

        let secondStartTimeTotal = this.myData[index].period_time[1].start_time.hour + Math.round((this.myData[index].period_time[1].start_time.minute / 60) * 100) / 100;

        let secondEndTimeTotal = this.myData[index].period_time[1].end_time.hour + Math.round((this.myData[index].period_time[1].end_time.minute / 60) * 100) / 100;
        if (this.myData[index].period_time[1].start_time.hour > this.myData[index].period_time[1].end_time.hour) {
          secondTimeWorkSign = Math.round(((24 - secondStartTimeTotal) + secondEndTimeTotal) * 100) / 100;
        } else {
          secondTimeWorkSign = Math.round((secondEndTimeTotal - secondStartTimeTotal) * 100) / 100;
        }

      }
      this.myData[index].hour_work = isNaN(firstTimeWorkSign + secondTimeWorkSign) ? "" : Math.round((firstTimeWorkSign + secondTimeWorkSign) * 100) / 100;
      if (this.myData[index].first_time || this.myData[index].seconde_time) {
        if (!this.myData[index].iteration_cycle) {
          this.myData[index].iteration_cycle = "WEEKLY";
        }
        if (!this.myData[index].number_word_day) {
          this.myData[index].number_word_day = 1;
        }
        if (!this.myData[index].day_off_number) {
          this.myData[index].day_off_number = 1;
        }
      }
      if (!this.myData[index].first_time && !this.myData[index].seconde_time) {
        if (this.myData[index].iteration_cycle) {
          this.myData[index].iteration_cycle = undefined
        }
        if (this.myData[index].number_word_day) {
          this.myData[index].number_word_day = undefined
        }
        if (this.myData[index].day_off_number) {
          this.myData[index].day_off_number = undefined
        }
      }
      this.forceUpdateUI();
      this.renderDataTable();
    },
    async fn_getValidShift() {
      const shifApiListRes = await ShiftApi.list({
        filters: "id!=" + this.$router.currentRoute.params.id,
        fields: 'id, name',
        limit: 500
      });
      this.mData.dataDefault.listValidShift = shifApiListRes.result;
    },
    async fn_getDataById(id) {
      const shiftApiRes = await ShiftApi.findById(id);
      if (shiftApiRes.result) {
        this.mData.dataForm = shiftApiRes.result;
        if (
          this.mData.dataForm.applied_end_time &&
          new Date(this.mData.dataForm.applied_end_time).getTime() <
            new Date().getTime()
        ) {
          this.validShift = false;
        }
        if (
          this.mData.dataForm.odd_names &&
          this.mData.dataForm.odd_names.length > 0
        ) {
          if (this.mData.dataForm.odd_names[0]) {
            this.mData.odd_names_first = this.mData.dataForm.odd_names[0];
          }
          if (this.mData.dataForm.odd_names[1]) {
            this.mData.odd_names_second = this.mData.dataForm.odd_names[1];
          }
        }
        if (this.mData.dataForm.extra_block_time) {
          this.mData.calculate_overtime = true;
        }
        if (
          this.mData.dataForm.work_days &&
          this.mData.dataForm.work_days.length > 0
        ) {
          this.mData.dataForm.work_days.forEach(item => {
            if (
              (item.period_time[0] &&
                item.period_time[0].start_time &&
                item.period_time[0].end_time) ||
              (item.period_time[1] &&
                item.period_time[1].start_time &&
                item.period_time[1].end_time)
            ) {
              if (
                item.period_time[0].start_time.hour == undefined &&
                item.period_time[0].end_time.hour == undefined &&
                item.period_time[1].start_time.hour == undefined &&
                item.period_time[1].end_time.hour == undefined
              ) {
                item.iteration_cycle = undefined
                item.number_word_day = undefined
                item.day_off_number = undefined
              }
            }
            if (
              item.period_time[0] &&
              item.period_time[0].start_time &&
              item.period_time[0].end_time &&
              item.period_time[0] &&
              item.period_time[0].start_time.hour != undefined &&
              item.period_time[0].end_time.hour != undefined &&
              item.period_time[0].start_time.hour >= 0 &&
              item.period_time[0].end_time.hour >= 0
            ) {
              item.first_time =
                (item.period_time[0].start_time.hour && item.period_time[0].start_time.hour >= 10 ? item.period_time[0].start_time.hour : "0" + item.period_time[0].start_time.hour) +
                  ":" +
                 (item.period_time[0].start_time.minute && item.period_time[0].start_time.minute >= 10 ? item.period_time[0].start_time.minute : "0" + item.period_time[0].start_time.minute) + " - " +
                (item.period_time[0].end_time.hour && item.period_time[0].end_time.hour >= 10 ? item.period_time[0].end_time.hour : "0" + item.period_time[0].end_time.hour) +
                  ":" +
                  (item.period_time[0].end_time.minute && item.period_time[0].end_time.minute >= 10 ?  item.period_time[0].end_time.minute : "0" + item.period_time[0].end_time.minute)
              ;

              item.firstStartTimeTotal = item.period_time[0].start_time.hour + Math.round((item.period_time[0].start_time.minute / 60) * 100) / 100;

              item.firstEndTimeTotal = item.period_time[0].end_time.hour + Math.round((item.period_time[0].end_time.minute / 60) * 100) / 100;
              if (item.firstStartTimeTotal > item.firstEndTimeTotal) {
                item.firstTimeWorkSign = Math.round(((24 - item.firstStartTimeTotal) + item.firstEndTimeTotal) * 100) / 100;
              } else {
                item.firstTimeWorkSign = Math.round((item.firstEndTimeTotal - item.firstStartTimeTotal) * 100) / 100;
              }

            }
            //Thời gian cả 2
            if (
              item.period_time[1] &&
              item.period_time[1].start_time &&
              item.period_time[1].end_time &&
              item.period_time[1] &&
              item.period_time[1].start_time.hour != undefined &&
              item.period_time[1].end_time.hour != undefined &&
              item.period_time[1].start_time.hour >= 0 &&
              item.period_time[1].end_time.hour >= 0
            ) {
              item.seconde_time =
                (item.period_time[1].start_time.hour && item.period_time[1].start_time.hour >= 10 ? item.period_time[1].start_time.hour : "0" + item.period_time[1].start_time.hour) +
                  ":" +
                  (item.period_time[1].start_time.minute && item.period_time[1].start_time.minute >= 10 ? item.period_time[1].start_time.minute : "0" + item.period_time[1].start_time.minute) + " - " +
                (item.period_time[1].end_time.hour && item.period_time[1].end_time.hour >= 10 ? item.period_time[1].end_time.hour : "0" + item.period_time[1].end_time.hour) +
                  ":" +
                  (item.period_time[1].end_time.minute && item.period_time[1].end_time.minute >= 10 ? item.period_time[1].end_time.minute : "0" + item.period_time[1].end_time.minute);

              item.secondStartTimeTotal = item.period_time[1].start_time.hour + Math.round((item.period_time[1].start_time.minute / 60) * 100) / 100;

              item.secondEndTimeTotal = item.period_time[1].end_time.hour + Math.round((item.period_time[1].end_time.minute / 60) * 100) / 100;

              if (item.secondStartTimeTotal > item.secondEndTimeTotal) {
                item.secondTimeWorkSign = Math.round(((24 - item.secondStartTimeTotal) + item.secondEndTimeTotal) * 100) / 100;
              } else {
                item.secondTimeWorkSign = Math.round((item.secondEndTimeTotal - item.secondStartTimeTotal) * 100) / 100;
              }

            }
            item.hour_work = Math.round(((item.firstTimeWorkSign ? item.firstTimeWorkSign : 0) + (item.secondTimeWorkSign ? item.secondTimeWorkSign : 0)) * 100) / 100;

            delete item.firstTimeWorkSign;
            delete item.secondTimeWorkSign;
          });
        }
        this.myData = this.mData.dataForm.work_days;
        // console.log('this.myData', this.myData)
      }
    },
    submitForm(type) {
      if (
        this.mData.dataForm.applied_start_time &&
        this.mData.dataForm.applied_end_time
      ) {
        if (
          new Date(this.mData.dataForm.applied_end_time).getTime() <
          new Date(this.mData.dataForm.applied_start_time).getTime()
        ) {
          window.toastr.warning(
            "Thời gian hiệu lực tới phải lớn hơn hoặc bằng thời gian hiệu lực từ!"
          );
          this.$refs.start_time.focus();
          return;
        }
      }
      this.$refs["myForm"].validate(async valid => {
        if (valid) {
          //Check chọn giờ làm việc
          let checkChooseHourWork = this.myData.filter(e => {
            return e.period_time[0].start_time.hour
          });
          if (this.mData.dataForm.is_odd_shift) {
            if (!this.mData.odd_names_first || !this.mData.odd_names_second) {
              window.toastr.warning("Vui lòng nhập tên ca lẻ");
              return;
            } else if (
              this.mData.odd_names_first &&
              this.mData.odd_names_second
            ) {
              let regex = /^[a-zA-Z0-9ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĐĨŨƠàáâãèéêìíòóôõùúđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỂẾưăạảấầẩẫậắằẳẵặẹẻẽềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/g;
              let checkFirst = regex.test(this.mData.odd_names_first);
              regex.lastIndex = 0;
              let checkSecond = regex.test(this.mData.odd_names_second);
              regex.lastIndex = 0;
              if (checkFirst === false || checkSecond === false) {
                window.toastr.warning("Tên ca lẻ chỉ nhập a-z, A-Z, 0-9");
                return;
              }
            }
            let checkFirstChooseHourWork = this.myData.filter(e => {
              return !e.period_time[0].start_time.hour && e.seconde_time;
            });
            let checkSecondChooseHourWork = this.myData.filter(e => {
              return e.period_time[0].start_time.hour && !e.seconde_time;
            });
            if (
              checkFirstChooseHourWork &&
              checkFirstChooseHourWork.length > 0
            ) {
              window.toastr.warning(
                "Vui lòng nhập thời gian làm việc ca lẻ đầu tiên"
              );

              return;
            }
            if (
              checkSecondChooseHourWork &&
              checkSecondChooseHourWork.length > 0
            ) {
              window.toastr.warning(
                "Vui lòng nhập thời gian làm việc ca lẻ thứ hai"
              );
              return;
            }
            let checkTime = false;
            this.myData.forEach((e, i) => {
              if (
                e.first_time &&
                e.first_time[1] &&
                e.seconde_time &&
                e.seconde_time[0]
              ) {
                let endHourFirstTime = e.first_time[1].split(":");
                let startHourSecondTime = e.seconde_time[0].split(":");
                let now = new Date();
                let endTimeFirst = new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate(),
                  endHourFirstTime[0],
                  endHourFirstTime[1],
                  0
                ).getTime();
                let startTimeSecond = new Date(
                  now.getFullYear(),
                  now.getMonth(),
                  now.getDate(),
                  startHourSecondTime[0],
                  startHourSecondTime[1],
                  0
                ).getTime();
                if (endTimeFirst > startTimeSecond) {
                  window.toastr.warning(
                    "Thời gian bắt đầu của ca lẻ sau phải lớn hơn thời gian kết thúc của ca lẻ trước!"
                  );
                  checkTime = true;
                  return;
                }
              }
            });
            if (checkTime === true) {
              return;
            }
          }
          // return
          if (checkChooseHourWork && checkChooseHourWork.length == 0) {
            window.toastr.warning("Vui lòng nhập thời gian làm việc")
            return
          } else {
            //Check chọn chu kì lặp
            let checkInterationCycle = checkChooseHourWork.filter(e => {
              return !e.iteration_cycle
            })
            //Check nhập ngày công
            let checkNumberWorkDay = checkChooseHourWork.filter(e => {
              return !e.number_word_day
            })
            //Check nhập ngày nghỉ quy đổi
            let checkNumberDayoff = checkChooseHourWork.filter(e => {
              return !e.day_off_number
            })
            if (
              checkInterationCycle &&
              checkInterationCycle.length > 0 &&
              checkNumberWorkDay &&
              checkNumberWorkDay.length > 0 &&
              checkNumberDayoff &&
              checkNumberDayoff.length > 0
            ) {
              window.toastr.warning("Vui lòng chọn chu kì lặp")
              window.toastr.warning("Vui lòng nhập ngày công lớn hơn 0")
              window.toastr.warning("Vui lòng nhập ngày ngày nghỉ quy đổi lớn hơn 0")
              return
            } else if (
              checkInterationCycle &&
              checkInterationCycle.length > 0
            ) {
              window.toastr.warning("Vui lòng chọn chu kì lặp")
              return
            } else if (checkNumberWorkDay && checkNumberWorkDay.length > 0) {
              window.toastr.warning("Vui lòng nhập ngày công lớn hơn 0")
              return
            } else if (checkNumberDayoff && checkNumberDayoff.length > 0) {
              window.toastr.warning("Vui lòng nhập ngày nghỉ quy đổi lớn hơn 0")
              return
            }
          }
          this.mData.dataForm.acceptance_time_start = {
            hour: 0,
            minute: 0
          };
          this.mData.dataForm.acceptance_time_end = {
            hour: 23,
            minute: 59
          };
          let data = MethodService.copyObject(this.mData.dataForm)
          if (this.mData.odd_names_first && this.mData.dataForm.is_odd_shift) {
            data.odd_names = [];
            data.odd_names.push(this.mData.odd_names_first);
            if (this.mData.odd_names_second) {
              data.odd_names.push(this.mData.odd_names_second);
            }
          } else if (!this.mData.dataForm.is_odd_shift) {
            data.odd_names = [this.mData.dataForm.name];
          }
          data.work_days = MethodService.copyObject(this.myData)
          data.work_days.forEach((day,index) => {
            if (!day.iteration_cycle) day.iteration_cycle = 'WEEKLY'
            day.period_time.forEach(time => {
              if (!time.start_time.hour && !time.start_time.minute) time.start_time = {}
              if (!time.end_time.hour && !time.end_time.minute) time.end_time = {}
            })
          })
          delete data.acceptance_time_starts;
          delete data.acceptance_time_ends;
          let time = new Date(this.mData.dataForm.applied_end_time);
          data.applied_end_time = new Date(
            time.getFullYear(),
            time.getMonth(),
            time.getDate(),
            23,
            59,
            59
          ).toISOString();

          try {
            if (type == "create") {
              await ShiftApi.create(data);
              this.fn_resetForm();
              this.fn_go();
            } else if (type == "update") {
              await ShiftApi.update(data);
              this.fn_resetForm();
              this.fn_go();
            }
          } catch (error) {
            if (error && error.code === 500) {
              window.toastr.error("Trùng mã ca làm việc");
            } else {
              if (type == "create") {
                window.toastr.error("Thêm mới không thành công");
              } else if (type == "update") {
                window.toastr.error("Cập nhật không thành công");
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    changeOddName(value, type) {
      let regex = /^[a-zA-Z0-9ÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĐĨŨƠàáâãèéêìíòóôõùúđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỂẾưăạảấầẩẫậắằẳẵặẹẻẽềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/g;
      let check = regex.test(value);
      if (check === false) {
        window.toastr.warning("Tên ca lẻ chỉ nhập a-z, A-Z, 0-9");
        this.checkValidate = false;
        this.$refs[type].focus();
      } else {
        this.checkValidate = true;
      }
    },
    changeShift() {},
    async division() {
      let data = {
        FromShiftId: this.mData.division_id,
        ToShiftId: this.$router.currentRoute.params.id,
        StartTime: this.mData.timeStart
      };
      if (!this.mData.division_id) {
        window.toastr.error("Vui lòng chọn ca muốn phân!");
        return;
      }
      if (!this.mData.timeStart) {
        window.toastr.error("Vui lòng chọn thời gian bắt đầu!");
        return;
      }
      if (
        new Date(this.mData.timeStart).getTime() <
          new Date(this.mData.dataForm.applied_start_time) ||
        new Date(this.mData.timeStart).getTime() >
          new Date(this.mData.dataForm.applied_end_time)
      ) {
        window.toastr.error(
          "Thời gian bắt đầu phải nằm trong khoảng thời gian hiệu lực của ca!"
        );
        return;
      }
      try {
        await ShiftApi.SuggestAssignShift(data);
        window.toastr.success("Phân ca thành công");
        this.mData.dialogHint = !this.mData.dialogHint;
      } catch (e) {
        if (e.code == 404) {
          window.toastr.error("Vui lòng chọn ca muốn phân!");
        } else if (e.code == 401) {
          window.toastr.error("Ca làm việc hiện tại không tồn tại!");
        } else {
          window.toastr.error(e.result.message);
        }
      }
    },
    async showHideDialogHint() {
      await this.fn_getValidShift();
      this.mData.dialogHint = !this.mData.dialogHint;
      let start = new Date(this.mData.dataForm.applied_start_time).getTime();
      let end = new Date(this.mData.dataForm.applied_end_time).getTime();
      let now = new Date();
      let timeStartDisable = "";
      if (start > new Date(now).getTime()) {
        timeStartDisable = start;
      } else if (start < new Date(now).getTime()) {
        timeStartDisable = now;
      }
      if (start > new Date(now).getTime()) {
        this.pickerOptions = {
          disabledDate(time) {
            return time.getTime() > end || time.getTime() < timeStartDisable;
          }
        };
      } else if (start <= new Date(now).getTime()) {
        this.pickerOptions = {
          disabledDate(time) {
            return time.getTime() > end || time.getTime() <= timeStartDisable;
          }
        };
      }
    },
    renderDataTable() {
      for (let i = 2; i <= 8; i++) {
        let data = MethodService.copyObject(ShiftModel.dataTable);
        data.name = String(i);

        this.myData.push(data);
      }
      if (this.myData.length > 7) {
        this.myData.splice(7, this.myData.length - 1);
      }
    },
    splitTime(time) {
      let timearray = time.split(":");
      return timearray;
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_go() {
      this.$router.go(-1);
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_resetFormDivision() {
      this.mData.dialogHint = false;
      this.$refs["myListForm"].resetFields();
    },
    changeStatusPassDay(){
      if (this.mData.dataForm.is_pass_day === false) {
        this.myData.forEach(e => {
          if (e.first_time) {
            e.first_time = undefined;
            e.hour_work = undefined;
            e.period_time =  [
              {
                start_time:
                {
                  hour: undefined,
                  minute: undefined,
                },
                end_time:
                {
                  hour: undefined,
                  minute: undefined,
                }
              },
              {
                start_time:
                {
                  hour: undefined,
                  minute: undefined,
                },
                end_time:
                {
                  hour: undefined,
                  minute: undefined,
                }
              }
            ]
          }
          if (e.seconde_time) {
            e.seconde_time = undefined;
          }
        })
        this.renderDataTable();
      }
    }
  },
  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-Timekeeping-TimekeepingConfig-" + this.mData.moduleName + "-create"
    ) {
      this.mData.viewMode = "create";
      this.renderDataTable();
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-Timekeeping-TimekeepingConfig-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-Timekeeping-TimekeepingConfig-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
}
</script>

<style scoped>
.fake-input_elementUi {
  text-align: center;
  width: 100%;
  padding: 0 10px;
  border: 1px solid #c8ced3;
  background: var(--white);
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.10);
  border-radius: 10px !important;
  height: 42px !important;
  font-size: 14px;
  color: #606266;
}
.fake-input_elementUi:focus {
  border: 1px solid rgba(250, 164, 4, 0.5);
  outline: 0;
}
.fake-input_elementUi.disabled{
  background-color: #F5F7FA;
}
.titel_phan_ca {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
::v-deep .el-radio {
  margin-bottom: 0;
}
::v-deep .el-dialog {
  width: 60%;
}
::v-deep .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
::v-deep .el-date-editor .el-range-input {
  width: 40%;
}
::v-deep .el-date-editor .el-range-separator {
  width: 10%;
}
.time-accept .el-form-item,
.extra_block_time .el-form-item {
  margin-bottom: 0;
}
::v-deep .time-accept .el-form-item--small .el-form-item__error {
  margin-left: 10px;
}
::v-deep .el-range-editor.is-disabled input {
  color: #444;
}
.work-brake {
  word-break: initial;
}
.bar-time {
  max-width: 900px;
  margin: 0 auto;
}
::v-deep .scroll-css {
  padding-left: 15px;
  padding-right: 15px;
}
::v-deep .el-form-item__label {
  margin-bottom: 0;
}
::v-deep .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 20px;
}
.title-work-day {
  display: flex;
  align-items: center;
}
.title-work-day .title {
  margin-right: 10px;
}
::v-deep .popper-popup {
  margin: 0 -10px;
  width: 300px;
}
::v-deep .popper-popup .popper-popup_box {
  word-break: break-word;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--grey);
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: var(--grey);
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: var(--grey);
}
</style>
